module.exports = __webpack_public_path__ + "img/word.4adf7340.png";